import * as environment from '../../../config/environment';
import { BaseAPI } from "../../BaseAPI";

class DinamikFormConfigRequest {
    sayfaKodu?: string;
    constructor(sayfaKodu?: string) {
        this.sayfaKodu = sayfaKodu;
    }
}

class DinamikFormConfigAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "DinamikFormConfig";
        super(baseUrl);
    }

    getFormConfig(sayfaKodu: string) {
        return this.post("getByPageCode", new DinamikFormConfigRequest(sayfaKodu));
    }

    getSayfaListesi() {
        return this.post("getSayfaListesi", {});
    }

    updateAlanlar(request: any) {
        return this.post("updateAlanlar", request);
    }
}

export default new DinamikFormConfigAPI();
export { DinamikFormConfigRequest };
